import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './user/styles/globals.css'; // Global responsive sidebar behaviors


import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
